import { CognitoUser } from 'amazon-cognito-identity-js';

export const getUserToken = (currentUser: CognitoUser): Promise<string> =>
  new Promise((resolve, reject) => {
    currentUser.getSession((err: Nullable<Error>, session: any) => {
      if (err) {
        reject(err);
        return;
      }

      resolve(session.getIdToken().getJwtToken());
    });
  });
